/* BASIC APP CONSTANTS */
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const APP_COOKIE_NAME = "APP_COOKIE_NAME";
export const USER_COOKIE_NAME = "USER_COOKIE_NAME";
export const PASS_COOKIE_NAME = "PASS_COOKIE_NAME";
export const USER_ID_COOKIE_NAME = "USER_ID_COOKIE_NAME";
export const SET_CURRENT_ROUTE = "SET_CURRENT_ROUTE";
export const SET_SIDE_MENU_STATE = "SET_SIDE_MENU_STATE";
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const CLOSE_NOTIFICATION = "CLOSE_NOTIFICATION";
export const SHOW_ACTION_MENU = "SHOW_ACTION_MENU";
export const HIDE_ACTION_MENU = "HIDE_ACTION_MENU";
export const SHOW_BOTTOM_TOOLBAR = "SHOW_BOTTOM_TOOLBAR";
export const HIDE_BOTTOM_TOOLBAR = "HIDE_BOTTOM_TOOLBAR";
export const SET_USER_LIST = "SET_USER_LIST";
export const EDIT_DISABLED_BUTTONS = "EDIT_DISABLED_BUTTONS";
export const SET_LOGS_LIST = "SET_LOGS_LIST";
export const THEME = "THEME";

/* <---- BASIC APP CONSTANTS ----> */

/* SOCKET CONSTANTS */
export const CONNECTED = "connected";
export const DISCONNECTED = "disconnected";
/* <---- SOCKET CONSTANTS ----> */

/* CONFIGURATION */
export const CONFIGURATION_FORM_TOOGLE_LOADING =
  "CONFIGURATION_FORM_TOOGLE_LOADING";
export const SET_CONFIGURATION = "SET_CONFIGURATION";
/* <---- CONFIGURATION ----> */

/* USER */
export const SET_PROFILE = "SET_PROFILE";
/* <---- USER ----> */

/* USERS */
export const ADD_NEW_USER = "ADD_NEW_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const OPEN_USER_FORM = "OPEN_USER_FORM";
export const CLOSE_USER_FORM = "CLOSE_USER_FORM";
export const EDIT_SELECTED_USER = "EDIT_SELECTED_USER";
export const USERS_FORM_TOOGLE_LOADING = "USERS_FORM_TOOGLE_LOADING";
/* <---- USERS ----> */

/* NOTE */
export const SET_NOTE_LIST = "SET_NOTE_LIST";
export const ADD_NEW_NOTE = "ADD_NEW_NOTE";
export const UPDATE_NOTE = "UPDATE_NOTE";
export const DELETE_NOTE = "DELETE_NOTE";
export const OPEN_NOTE_FORM = "OPEN_NOTE_FORM";
export const CLOSE_NOTE_FORM = "CLOSE_NOTE_FORM";
export const EDIT_SELECTED_NOTE = "EDIT_SELECTED_NOTE";
export const NOTE_FORM_TOOGLE_LOADING = "NOTE_FORM_TOOGLE_LOADING";
/* <---- NOTE ----> */

/* HISTORIC */
export const SET_HISTORIC_LIST = "SET_HISTORIC_LIST";
export const ADD_NEW_HISTORIC = "ADD_NEW_HISTORIC";
export const UPDATE_HISTORIC = "UPDATE_HISTORIC";
export const DELETE_HISTORIC = "DELETE_HISTORIC";
export const OPEN_HISTORIC_FORM = "OPEN_HISTORIC_FORM";
export const CLOSE_HISTORIC_FORM = "CLOSE_HISTORIC_FORM";
export const EDIT_SELECTED_HISTORIC = "EDIT_SELECTED_HISTORIC";
export const HISTORIC_FORM_TOOGLE_LOADING = "HISTORIC_FORM_TOOGLE_LOADING";
/* <---- HISTORIC ----> */

/* PRODUCT */
export const SET_PRODUCT_LIST = "SET_PRODUCT_LIST";
export const ADD_NEW_PRODUCT = "ADD_NEW_PRODUCT";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const OPEN_PRODUCT_FORM = "OPEN_PRODUCT_FORM";
export const CLOSE_PRODUCT_FORM = "CLOSE_PRODUCT_FORM";
export const EDIT_SELECTED_PRODUCT = "EDIT_SELECTED_PRODUCT";
export const PRODUCT_FORM_TOOGLE_LOADING = "PRODUCT_FORM_TOOGLE_LOADING";
/* <---- PRODUCT ----> */

/* EMAILUSER */
export const SET_EMAILUSER_LIST = "SET_EMAILUSER_LIST";
export const ADD_NEW_EMAILUSER = "ADD_NEW_EMAILUSER";
export const UPDATE_EMAILUSER = "UPDATE_EMAILUSER";
export const DELETE_EMAILUSER = "DELETE_EMAILUSER";
export const OPEN_EMAILUSER_FORM = "OPEN_EMAILUSER_FORM";
export const CLOSE_EMAILUSER_FORM = "CLOSE_EMAILUSER_FORM";
export const EDIT_SELECTED_EMAILUSER = "EDIT_SELECTED_EMAILUSER";
export const EMAILUSER_FORM_TOOGLE_LOADING = "EMAILUSER_FORM_TOOGLE_LOADING";
/* <---- EMAILUSER ----> */

/* TEMPLATE */
export const SET_TEMPLATE_LIST = "SET_TEMPLATE_LIST";
export const ADD_NEW_TEMPLATE = "ADD_NEW_TEMPLATE";
export const UPDATE_TEMPLATE = "UPDATE_TEMPLATE";
export const DELETE_TEMPLATE = "DELETE_TEMPLATE";
export const OPEN_TEMPLATE_FORM = "OPEN_TEMPLATE_FORM";
export const CLOSE_TEMPLATE_FORM = "CLOSE_TEMPLATE_FORM";
export const EDIT_SELECTED_TEMPLATE = "EDIT_SELECTED_TEMPLATE";
export const TEMPLATE_FORM_TOGGLE_LOADING = "TEMPLATE_FORM_TOGGLE_LOADING";
/* <---- TEMPLATE ----> */

/* OFFER */
export const SET_OFFER_LIST = "SET_OFFER_LIST";
export const ADD_NEW_OFFER = "ADD_NEW_OFFER";
export const UPDATE_OFFER = "UPDATE_OFFER";
export const DELETE_OFFER = "DELETE_OFFER";
export const OPEN_OFFER_FORM = "OPEN_OFFER_FORM";
export const CLOSE_OFFER_FORM = "CLOSE_OFFER_FORM";
export const EDIT_SELECTED_OFFER = "EDIT_SELECTED_OFFER";
export const OFFER_FORM_TOOGLE_LOADING = "OFFER_FORM_TOOGLE_LOADING";
/* <---- OFFER ----> */

/* VISIT */
export const SET_VISIT_LIST = "SET_VISIT_LIST";
export const ADD_NEW_VISIT = "ADD_NEW_VISIT";
export const UPDATE_VISIT = "UPDATE_VISIT";
export const DELETE_VISIT = "DELETE_VISIT";
export const OPEN_VISIT_FORM = "OPEN_VISIT_FORM";
export const CLOSE_VISIT_FORM = "CLOSE_VISIT_FORM";
export const EDIT_SELECTED_VISIT = "EDIT_SELECTED_VISIT";
export const VISIT_FORM_TOOGLE_LOADING = "VISIT_FORM_TOOGLE_LOADING";
/* <---- VISIT ----> */

/* CUSTOMER */
export const SET_CUSTOMER_LIST = "SET_CUSTOMER_LIST";
export const ADD_NEW_CUSTOMER = "ADD_NEW_CUSTOMER";
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const DELETE_CUSTOMER = "DELETE_CUSTOMER";
export const OPEN_CUSTOMER_FORM = "OPEN_CUSTOMER_FORM";
export const CLOSE_CUSTOMER_FORM = "CLOSE_CUSTOMER_FORM";
export const EDIT_SELECTED_CUSTOMER = "EDIT_SELECTED_CUSTOMER";
export const CUSTOMER_FORM_TOOGLE_LOADING = "CUSTOMER_FORM_TOOGLE_LOADING";
/* <---- CUSTOMER ----> */

/* ROUTES */
export const SET_ALL_ROUTES = "SET_ALL_ROUTES";
export const UPDATE_ROUTE = "UPDATE_ROUTE";
/* <---- ROUTES ----> */

/* ALERT */
export const SET_ALERT_LIST = "SET_ALERT_LIST";
export const ADD_NEW_ALERT = "ADD_NEW_ALERT";
export const UPDATE_ALERT = "UPDATE_ALERT";
export const DELETE_ALERT = "DELETE_ALERT";
export const OPEN_ALERT_FORM = "OPEN_ALERT_FORM";
export const CLOSE_ALERT_FORM = "CLOSE_ALERT_FORM";
export const EDIT_SELECTED_ALERT = "EDIT_SELECTED_ALERT";
export const ALERT_FORM_TOOGLE_LOADING = "ALERT_FORM_TOOGLE_LOADING";
/* <---- ALERT ----> */
